import React from "react";
import { Flex } from "@chakra-ui/react";

const SmallContainer = ({
  width = "100%",
  backgroundColor,
  flexDirection = "column",
  alignItems,
  height = "100%",
  ...props
}) => {
  return (
    <Flex
      width={width}
      backgroundColor={backgroundColor}
      flexDirection={flexDirection}
      alignItems={alignItems}
      {...props}
    />
  );
};

export default SmallContainer;
